var GenericHero = (function($) {
  var init = () => {
    // _initResize();
  };

  module.exports = {
    init: init
  };
})(jQuery);
